import React from 'react'
import {createRoot} from 'react-dom/client'

import {IntlProvider} from 'react-intl';

import {Route,Switch} from 'wouter';

import {createTheme,ThemeProvider} from '@mui/material/styles';
import {FrontPage} from '@growcloud-io/gcio-public/components/FrontPage'
import {EnquiryPage} from '@growcloud-io/gcio-public/components/EnquiryPage'
import {LandingPage} from '@growcloud-io/gcio-public/components/LandingPage'
import {ApiPage} from '@growcloud-io/gcio-public/components/ApiPage'
import {FaqPage} from '@growcloud-io/gcio-public/components/FaqPage'
import {FeaturesPage} from '@growcloud-io/gcio-public/components/FeaturesPage'
import {HowItWorksPage} from '@growcloud-io/gcio-public/components/HowItWorksPage'
import {ResourcesPage} from '@growcloud-io/gcio-public/components/ResourcesPage'
import {withGcSiteLayout,withMinimalGcSiteLayout} from '@growcloud-io/gcio-public/components/GcSiteLayouts'
import {CaseStudyPage} from '@growcloud-io/gcio-public/components/CaseStudyPage'
import {ResourcePage} from '@growcloud-io/gcio-public/components/ResourcePage'

import {ErrorBoundary} from "react-error-boundary";
import CssBaseline from '@mui/material/CssBaseline';


const WithedLandingPage = withMinimalGcSiteLayout(LandingPage)
const WithedEnquiryPage = withMinimalGcSiteLayout(EnquiryPage)
const WithedFrontPage = withGcSiteLayout(FrontPage)
const WithedApiPage = withGcSiteLayout(ApiPage)
const WithedFaqPage = withGcSiteLayout(FaqPage)
const WithedFeaturesPage = withGcSiteLayout(FeaturesPage)
const WithedHowItWorksPage = withGcSiteLayout(HowItWorksPage)
const WithedResourcesPage = withGcSiteLayout(ResourcesPage)
const WithedCaseStudyPage = withGcSiteLayout(CaseStudyPage)
const WithedResourcePage = withGcSiteLayout(ResourcePage)

const theme = createTheme({
  drawerWidth:{width:240},
  typography:{
    fontFamily:'Roboto,Arial'
  }
});

const GlobalError = () => (<>OOPS</>);

const ErrorBoundaryLayout = () => (
  <ErrorBoundary FallbackComponent={GlobalError}>

  </ErrorBoundary>
);

const GcSite = ({theme,store}) => {
  if (!theme) {
    return (<>no theme</>)
  }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <IntlProvider
        locale={'en'}
        messages={{}}>
        <Site/>
      </IntlProvider>
    </ThemeProvider>
  )
}

const Site = ({theme,store}) => {
  return (
    <>
      <Switch>
        <Route
          path="/"
          key="/"
        >
          {(params) => (
            <WithedLandingPage/>
          )}
        </Route>
        <Route
          path="/beta"
          key="/beta"
        >
          {(params) => (
            <WithedFrontPage/>
          )}
        </Route>
        <Route
          path="/enquiry"
          key="/enquiry"
        >
          {(params) => (
            <WithedEnquiryPage/>
          )}
        </Route>
        <Route
          path="/features"
          key="/features"
        >
          {(params) => (
            <WithedFeaturesPage/>
          )}
        </Route>
        <Route
          path="/api"
          key="/api"
        >
          {(params) => (
            <WithedApiPage/>
          )}
        </Route>
        <Route
          path="/faq"
          key="/faq"
        >
          {(params) => (
            <WithedFaqPage/>
          )}
        </Route>
        <Route
          path="/how-it-works"
          key="/how-it-works"
        >
          {(params) => (
            <WithedHowItWorksPage/>
          )}
        </Route>
        <Route
          path="/resources"
          key="/resources"
        >
          {(params) => (
            <WithedResourcesPage/>
          )}
        </Route>
        <Route
          path="/case-study/:caseStudySlug"
          key="/case-study"
        >
          {(params) => (
            <WithedCaseStudyPage/>
          )}
        </Route>
        <Route
          path="/resource/:resourceSlug"
          key="/resource"
        >
          {(params) => (
            <WithedResourcePage/>
          )}
        </Route>
      </Switch>
    </>
  )
}
createRoot(document.getElementById('root')).render(<GcSite theme={theme}/>)
